var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seo-and-web"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9745 7.08938C14.0167 7.38101 14.0381 7.67637 14.0381 7.97099C14.0381 8.2656 14.0167 8.56096 13.9744 8.85256L15.8706 10.1686L13.8062 13.7443L11.7181 12.7601C11.2085 13.1638 10.6452 13.479 10.037 13.7015V11.648C10.6294 11.309 11.1323 10.8313 11.5029 10.2531C11.9393 9.57216 12.1699 8.78306 12.1699 7.97099C12.1699 6.13165 10.9955 4.51338 9.24756 3.94408L8.63588 3.74487V6.81242L7.9353 7.37288L7.23473 6.81242V3.74487L6.62305 3.94408C4.8751 4.51338 3.70072 6.13165 3.70072 7.97099C3.70072 8.78306 3.93135 9.57216 4.36766 10.2531C4.73825 10.8313 5.2412 11.309 5.83355 11.648V13.7015C5.22545 13.479 4.66206 13.1639 4.15251 12.7601L2.06442 13.7443L0 10.1686L1.89613 8.85259C1.85388 8.56096 1.83252 8.2656 1.83252 7.97099C1.83252 7.67637 1.85388 7.38101 1.89613 7.08938L0 5.77333L2.06442 2.19766L4.15254 3.18189C4.61813 2.81314 5.12961 2.51731 5.6793 2.29888L5.87088 0H9.99973L10.1913 2.29888C10.741 2.51731 11.2524 2.81314 11.718 3.18189L13.8062 2.19766L15.8706 5.77333L13.9745 7.08938ZM9.36706 10.9457L9.10293 11.0731V15.942H6.76768V11.0731L6.50355 10.9457C5.36833 10.3982 4.63482 9.23053 4.63482 7.97099C4.63482 6.76438 5.28321 5.67976 6.30063 5.10199V7.26138L7.9353 8.56912L9.56998 7.26138V5.10199C10.5874 5.67976 11.2358 6.76438 11.2358 7.97099C11.2358 9.23053 10.5023 10.3982 9.36706 10.9457Z",
    fill: "#77928B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeSetting);
export default __webpack_public_path__ + "static/media/office-setting.cbc4ea9e921f45fad322a49723e20841.svg";
export { ForwardRef as ReactComponent };